
















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from 'vuex';
import { EventBus } from '@/event-bus';
import { IChangePassword } from '@/features/account/api/auth.interfaces';

@Component({
  computed: {
    ...mapGetters({
      firstName: 'user/firstName',
      lastName: 'user/lastName',
      email: 'user/email',
      signUpDate: 'user/signUpDate',
      trialExpireDate: 'user/trialExpireDate',
      monthlyBillingDate: 'user/monthlyBillingDate',
    }),
  },
})
export default class ManageUser extends Vue {
  model: string = '';
  valid: boolean = false;
  oldPassword: string = '';
  newPassword: string = '';
  confirmNewPassword: string = '';
  loading: boolean = false;

  $refs: {
    form: any;
  };

  changePassword() {
    var self = this;
    if (this.$refs.form.validate()) {
      let changePassword: IChangePassword = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      };

      self.loading = true;

      this.$store
        .dispatch('auth/changePassword', changePassword)
        .then((result: any) => {
          self.loading = false;
          EventBus.$emit('api-success', { message: 'Password changed successfully' });
        })
        .catch((error: any) => {
          self.loading = false;
        });
    }
  }

  mounted() {
    this.$store.dispatch('user/get');
  }
}
